import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import polylabel from 'polylabel'
import type { TIrrigationZoneEmitterId, TProperty } from 'stores/fieldAssetStore/helperTypes'
import { sortByClosestPoints } from 'utils/sortByClosestPoints'
import { lngLatStringToLngLatObject } from './lngLatStringToLngLatObject'

type TPointResponse = {
  lng: number
  lat: number
  irrigationZoneEmitterId: TIrrigationZoneEmitterId
}

export const getClosestIrrigationZoneEmitterInPropertyForAPoint = ({
  anchorCoordinates,
  property,
}: {
  anchorCoordinates: { lng: number; lat: number }
  property: TProperty
}): TPointResponse | null => {
  const point = Object.values(property.points || {}).find((p) => {
    const isPointIrrigation = p.configuration.irrigationEmitterTypesAvailable
    const { lng, lat } = lngLatStringToLngLatObject(p.lngLat)

    return isPointIrrigation && lng === anchorCoordinates.lng && lat === anchorCoordinates.lat
  })

  const [closest] = Object.values(property.irrigationZoneEmitters ?? {})
    .filter((zoneData) => {
      const { irrigationZoneEmitterId, emitterType } = zoneData

      if (point) {
        // filter only zones this point is inside
        return (
          point?.configuration?.irrigationEmitterTypesAvailable?.includes(emitterType) &&
          point.irrigationEmitterZoneIds?.includes(irrigationZoneEmitterId)
        )
      } else {
        const pointsThatHaveThisZone = Object.values(property.points || {}).filter(
          (p) =>
            p.configuration.irrigationEmitterTypesAvailable?.includes(emitterType) &&
            p.irrigationEmitterZoneIds?.includes(irrigationZoneEmitterId),
        )

        return pointsThatHaveThisZone.length
      }
    })
    .map((f) => {
      const { coordinates } = JSON.parse(f.geometry) as SharedTypes.TGeoJsonMultiPolygon
      const [lng, lat] = polylabel([coordinates[0][0]], 1.0)

      return { lng, lat, irrigationZoneEmitterId: f.irrigationZoneEmitterId }
    })
    .sort(sortByClosestPoints(anchorCoordinates))

  if (closest) return closest

  return null
}
